import React, { FC } from "react";
import Heading from "components/Heading/Heading";

export interface Statistic {
  id: string;
  heading: string;
  subHeading: string;
}

const FOUNDER_DEMO: Statistic[] = [
  {
    id: "1",
    heading: "Easy Booking Process",
    subHeading:
      "Gone are the days of waiting in line or making endless phone calls to book appointments . With Feelaxo.com, booking your desired beauty and wellness services is just a few clicks away.",
  },
  {
    id: "2",
    heading: "Discover Beauty & Wellness",
    subHeading: "Featuring an extensive network of salons, spas, and wellness centers, Feelaxo.com offers a vast array of services catering to your every need.",
  },
  {
    id: "3",
    heading: "Empowering Businesses",
    subHeading:
      "Feelaxo.com offers a unique opportunity for businesses to showcase their services to a vast audience. ",
  },
];

export interface SectionStatisticProps {
  className?: string;
}

const SectionStatistic: FC<SectionStatisticProps> = ({ className = "" }) => {
  return (
    <div className={`nc-SectionStatistic relative ${className}`}>
      <Heading
        desc=" Feelaxo.com is more than just a booking platform"
      >
      Why Feelaxo ?
      </Heading>
      <div className="grid md:grid-cols-2 gap-6 lg:grid-cols-3 xl:gap-8">
        {FOUNDER_DEMO.map((item) => (
          <div
            key={item.id}
            className="p-6 bg-neutral-50 dark:bg-neutral-800 rounded-2xl dark:border-neutral-800"
          >
            <h3 className="text-2xl font-semibold leading-none text-neutral-900 md:text-3xl dark:text-neutral-200">
              {item.heading}
            </h3>
            <span className="block text-sm text-neutral-500 mt-3 sm:text-base dark:text-neutral-400">
              {item.subHeading}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SectionStatistic;
